import { render, staticRenderFns } from "./StackLayout.vue?vue&type=template&id=3fff6c38&scoped=true"
import script from "./StackLayout.vue?vue&type=script&lang=js"
export * from "./StackLayout.vue?vue&type=script&lang=js"
import style0 from "./StackLayout.vue?vue&type=style&index=0&id=3fff6c38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fff6c38",
  null
  
)

export default component.exports